export default "__VITE_ASSET__DtI4QEbz__"